import { ColumnType } from "antd/lib/table";
import { OrderItems } from "../stores";
import { useItemsColumns } from "./useItemsColumns";
import { useTranslation } from "react-i18next";

export function useItemsColumnsPDF() {
    const itemsColumns = useItemsColumns();
    const { t } = useTranslation();

    return itemsColumns
        .map((x: ColumnType<OrderItems>) => {
            if (x.dataIndex === "currentItemStatus")
                x.render = (value: any, record: OrderItems, index: number) => t(`Orders.StatusName.${value}`);
            return x;
        }
        )
        .filter((x: ColumnType<OrderItems>) => x.dataIndex !== "dmsAvailableQuantity")
}